import { create } from "zustand";
import { persist, PersistStorage } from "zustand/middleware";

interface MasterAuthState {
    accessToken?: string;
    isGuest: boolean;
    c_code?: string;
    c_company?: string;
    c_company_number?: string;
    c_tel?: string;
    c_post?: string;
    c_addr1?: string;
    c_addr2?: string;
    c_month_yn?: string;
    loginAsMember: (data: Partial<MasterAuthState>) => void;
    logoutToGuest: () => void;
}

const customStorage: PersistStorage<MasterAuthState> = {
    getItem: name => {
        const item = localStorage.getItem(name);
        return item ? JSON.parse(item) : null;
    },
    setItem: (name, value) => {
        localStorage.setItem(name, JSON.stringify(value));
    },
    removeItem: name => {
        localStorage.removeItem(name);
    },
};

export const useMasterAuthStore = create(
    persist<MasterAuthState>(
        set => ({
            isGuest: true,

            loginAsMember: data => {
                set({
                    isGuest: false,
                    ...data,
                });
            },

            logoutToGuest: () => {
                set({
                    accessToken: undefined,
                    isGuest: true,
                    c_code: undefined,
                    c_company: undefined,
                    c_company_number: undefined,
                    c_tel: undefined,
                    c_post: undefined,
                    c_addr1: undefined,
                    c_addr2: undefined,
                    c_month_yn: undefined,
                });
            },
        }),
        {
            name: "master-auth-storage",
            storage: customStorage,
        },
    ),
);
